module.exports = __webpack_public_path__ + "img/09.9c4d666f.jpg";